<template lang="pug">
.description_detail.business.i_mlr_auto
  .container.i_mt_5
    .row
      .col-12.text-center
        h5 {{ table.Detail_area01_Title }}
    .row.i_mt_4
      .col-12
        img.table(:src="table.Detail_area01_Image")
      .col-12
        span.d-block.d-md-inline
          svg-icon.i_mt_2(iconClass="check_oval_b", className="check_oval")
          span.check_text.i_ml_1 該項保單之主要承保項目，不需另外加保。
        span.d-block.d-md-inline
          svg-icon.i_mt_2(iconClass="add_oval", className="check_oval")
          span.check_text.i_ml_1 該項保單之主要承保項目，不需另外加保。
        span.d-block.d-md-inline
          svg-icon.i_mt_2(iconClass="add_oval", className="check_oval")
          span.check_text.i_ml_1 不可附加承保。
  .container.i_mt_5
    .row.i_mt_6.btns.d-none.d-md-flex.justify-content-around.i_ptb_4.i_mlr_4.i_plr_8.i_plr_md_12
      a.btn_round.btn_border_blue(
        v-if="table.Detail_area01_Btn01_URL != null && table.Detail_area01_Btn01_URL != ''",
        :href="table.Detail_area01_Btn01_URL",
        target="_blank"
      ) {{ table.Detail_area01_Btn01_Title }}
      a.btn_round.btn_border_blue(
        v-if="table.Detail_area01_Btn02_URL != null && table.Detail_area01_Btn02_URL != ''",
        :href="table.Detail_area01_Btn02_URL",
        target="_blank"
      ) {{ table.Detail_area01_Btn02_Title }}
      a.btn_round.btn_border_blue(
        v-if="table.Detail_area01_Btn03_URL != null && table.Detail_area01_Btn03_URL != ''",
        :href="table.Detail_area01_Btn03_URL",
        target="_blank"
      ) {{ table.Detail_area01_Btn03_Title }}
      router-link.btn_round.btn_blue(
        v-if="true",
        tag="a",
        :to="{ name: 'CustomerServiceContactUs' }"
      ) 聯絡我們
    .row.i_mt_6.i_mlr_4.d-none.d-md-block
      p.i_body_l.note {{ table.Detail_area01_Note }}
  .container-fluid.bg_blue.i_ptb_8.i_mt_6.d-md-none
    .container
      .row.btns_sm_1.d-flex.justify-content-between
        a.btn_round.btn_border_blue(
          :href="table.Detail_area01_Btn01_URL",
          target="_blank"
        ) {{ table.Detail_area01_Btn01_Title }}
        a.btn_round.btn_border_blue(
          :href="table.Detail_area01_Btn02_URL",
          target="_blank"
        ) {{ table.Detail_area01_Btn02_Title }}
        a.btn_round.btn_border_blue(
          :href="table.Detail_area01_Btn03_URL",
          target="_blank"
        ) {{ table.Detail_area01_Btn03_Title }}

      .row.i_mt_6
        p.i_body_l.note 消費者於購買前，應詳閱各種銷售文件內容，本商品之預定費用率（預定附加費用率）最高 35％，最低 20.73％；如要詳細了解其他相關資訊，請洽本公司業務員、服務據點（免付費電話：0800-050-119）或網站（網址：https://www.tmnewa.com.tw），以保障您的權益。
      .row.btns_sm_2.justify-content-center
        router-link.btn_round.btn_blue(
          v-if="true",
          tag="a",
          :to="{ name: 'CustomerServiceContactUs' }"
        ) 聯絡我們
</template>

<script>
export default {
  name: "Table",
  props: {
    table: Object,
  },
};
</script>

<style lang="scss">
@import "@/assets/style/product/description/table";
.description_detail.business .btns {
  border-bottom: 3px $color_blue_btn solid;
  border-top: 3px $color_blue_btn solid;
}
</style>
